/**
 * TimeRuler — the sticky left gutter of the board that labels the hour ticks (06:00…24:00, or 00:00…24:00
 * when the night window is expanded). The `+`/`−` toggle expands/collapses the pre-06:00 night hours.
 */
import type { TFunction } from 'i18next';

import { DAY_END, HEAD_PAD, hoursToPx } from '../model';

interface TimeRulerProps {
  t: TFunction;
  dayStart: number;
  dayHours: number;
  nightExpanded: boolean;
  onToggleNight: () => void;
}

export function TimeRuler({ t, dayStart, dayHours, nightExpanded, onToggleNight }: TimeRulerProps) {
  const height = HEAD_PAD + hoursToPx(dayHours);
  const ticks = [];
  for (let h = dayStart; h <= DAY_END; h += 1) {
    ticks.push(
      <div key={h} className="tp-ruler-tick" style={{ top: HEAD_PAD + hoursToPx(h - dayStart) }}>
        <span className="tp-ruler-label">{String(h).padStart(2, '0')}:00</span>
      </div>
    );
  }
  return (
    <div className="tp-ruler" style={{ height, minHeight: height }}>
      <button
        type="button"
        className="tp-ruler-toggle"
        onClick={onToggleNight}
        title={nightExpanded ? t('costScheme.hideNight') : t('costScheme.showNight')}
      >
        {nightExpanded ? '−' : '+'}
      </button>
      {ticks}
    </div>
  );
}
